/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priority_LowInputs */

const en_priority_low = /** @type {(inputs: Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const de_priority_low = /** @type {(inputs: Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Priority_LowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const priority_low = /** @type {((inputs?: Priority_LowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priority_LowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_priority_low(inputs)
	return en_priority_low(inputs)
});